var Wdot;
(function (Wdot) {
    var ModalHelpWindow = (function () {
        function ModalHelpWindow() {
        }
        ModalHelpWindow.loadAjaxPost = function (width, height, isModal, url, d, postDialogFunction, title) {
            var ajax = new Wdot.Ajax();
            ajax.Post(url, d, function (data) {
                Wdot.ModalHelpWindow.loadHtml(width, height, isModal, data, postDialogFunction, title, "");
            }, null, Wdot.ModalWindow.ajaxContentType);
        };
        return ModalHelpWindow;
    }());
    ModalHelpWindow.dialog = $("#dialog");
    ModalHelpWindow.loadAjaxGet = function (width, height, isModal, url, postDialogFunction, title, style) {
        //console.log('WDOT.ModalHelpWindow.loadAjaxGet');
        var style = style;
        if (style === null || typeof style === 'undefined') {
            style = 'modal-classic';
        }
        Wdot.Ajax.prototype.Get(url, null, function (data) {
            Wdot.ModalHelpWindow.loadHtml(width, height, isModal, data, postDialogFunction, title, style);
        });
    };
    ModalHelpWindow.loadHtml = function (width, height, isModal, html, postDialogFunction, title, style) {
        //console.log('WDOT.ModalHelpWindow.loadHtml');
        if ($("#dialog").length == 0) {
            Wdot.ModalHelpWindow.dialog = $('<div id="dialog"></div>').appendTo('body');
        }
        Wdot.ModalHelpWindow.dialog.dialog({
            dialogClass: style,
            draggable: false,
            width: width,
            height: height,
            resizable: false,
            title: title || '',
            //position: { my: "center", at: "center", of: window },
            modal: isModal
        }).html(html);
        //dialog.dialog('option', 'position', 'center');
        var currentHeight = Wdot.ModalHelpWindow.dialog.dialog("option", "height");
        //console.log('dialog.currentHeight: ', currentHeight);
        if (postDialogFunction != undefined)
            postDialogFunction();
    };
    ModalHelpWindow.close = function () {
        Wdot.ModalHelpWindow.dialog.dialog('close');
    };
    Wdot.ModalHelpWindow = ModalHelpWindow;
})(Wdot || (Wdot = {}));
//# sourceMappingURL=ModalHelpWindow.js.map